import { BaseEntity } from "yt-ng-framework";

export class NedeljniNetoOtkupniFond extends BaseEntity{
    constructor(){
        super();
    }

    OrgJed: string = null;
    // Valuta: string = null;
    // Datum: Date = null;
    IznosUlaz1: number = null;
    IznosIzlaz1: number = null;
    IznosUlaz2: number = null;
    IznosIzlaz2: number = null;
    IznosUlaz3: number = null;
    IznosIzlaz3: number = null;
    IznosUlaz4: number = null;
    IznosIzlaz4: number = null;
    IznosUlaz5: number = null;
    IznosIzlaz5: number = null;
    IznosUlaz6: number = null;
    IznosIzlaz6: number = null;
    IznosUlaz7: number = null;
    IznosIzlaz7: number = null;
    UkupnoUlaz: number = null;
    UkupnoIzlaz: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.OrgJed=input.OrgJed;
        // this.Valuta = input.Valuta;
        // this.Datum = input.Datum;
        this.IznosUlaz1 = this.blankIfZero(input.IznosUlaz1);
        this.IznosIzlaz1= this.blankIfZero(input.IznosIzlaz1);
        this.IznosUlaz2 = this.blankIfZero(input.IznosUlaz2);
        this.IznosIzlaz2= this.blankIfZero(input.IznosIzlaz2);
        this.IznosUlaz3 = this.blankIfZero(input.IznosUlaz3);
        this.IznosIzlaz3= this.blankIfZero(input.IznosIzlaz3);
        this.IznosUlaz4 = this.blankIfZero(input.IznosUlaz4);
        this.IznosIzlaz4= this.blankIfZero(input.IznosIzlaz4);
        this.IznosUlaz5 = this.blankIfZero(input.IznosUlaz5);
        this.IznosIzlaz5= this.blankIfZero(input.IznosIzlaz5);
        this.IznosUlaz6 = this.blankIfZero(input.IznosUlaz6);
        this.IznosIzlaz6= this.blankIfZero(input.IznosIzlaz6);
        this.IznosUlaz7 = this.blankIfZero(input.IznosUlaz7);
        this.IznosIzlaz7= this.blankIfZero(input.IznosIzlaz7);
        this.UkupnoUlaz = this.blankIfZero(input.UkupnoUlaz);
        this.UkupnoIzlaz= this.blankIfZero(input.UkupnoIzlaz);
        return this;
    }

    Serialize(input: NedeljniNetoOtkupniFond){
        return input;
    }

    blankIfZero(value){
        return value == 0 ? "" : value;
    }
}